import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mkRadio" }
const _hoisted_2 = ["id", "name", "checked", "data-cy"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "name", "checked", "data-cy"]
const _hoisted_5 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "radio",
      id: _ctx.neinLabel,
      name: _ctx.name,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false))),
      checked: false === _ctx.modelValue,
      value: false,
      "data-cy": _ctx.neinLabel,
      required: "",
      "aria-required": "true",
      "aria-label": "Nein"
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: _ctx.neinLabel,
      class: "radiolabel"
    }, "Nein", 8, _hoisted_3),
    _createElementVNode("input", {
      type: "radio",
      id: _ctx.jaLabel,
      name: _ctx.name,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', true))),
      checked: true === _ctx.modelValue,
      value: true,
      "data-cy": _ctx.jaLabel,
      "aria-label": "Ja"
    }, null, 40, _hoisted_4),
    _createElementVNode("label", {
      for: _ctx.jaLabel,
      class: "radiolabel"
    }, "Ja", 8, _hoisted_5)
  ]))
}